const DIRTY_VALUES = new Set(["null", "none", "undefined", "nan"]);

/**
 * Normalises dirty API strings. The backend sometimes returns the literal
 * strings "null" / "None" (or empty/whitespace) instead of a real null, which
 * would otherwise render verbatim in the UI.
 */
export function cleanValue(value: unknown): string {
  if (value === null || value === undefined) return "";
  const str = String(value).trim();
  if (!str || DIRTY_VALUES.has(str.toLowerCase())) return "";
  return str;
}
